<template>
<div style="
    overflow-x: hidden;
">
  <!-- Preloader Starts -->
  <div class="preloader">
    <div class="spinner"></div>
  </div>
  <!-- Preloader End -->

  <!-- Header Area Starts -->
  <header class="header-area single-page x-header" id='testNavBar'>
    <div class="header-top">
        <div class="row">
          <div class="col-lg-12">
            <div class="tools">
              <div class="logo-area">
                <router-link to="/">
                  <img class="i" src="http://en.sc.ruc.edu.cn/static/images/logo-light.png" alt="logo">
                  <img class="i" src="http://en.sc.ruc.edu.cn/static/images/logo-light.png" alt="logo">
                </router-link>
              </div>
              <div class="tools-mod">
                <a class="tools-item lang"  href="http://sc.ruc.edu.cn/" target="_blank">中</a>
                <div class="tools-item search-mod">
                  <div class="search-box">
                    <div class="search-txt">
                      <input type="text" class="search-input" name="search" id="input1" placeholder="Search"></div>
                    <div class="search-btn">
                      <button class="search-submit" id="search" type="submit"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-lg-12" :class='{ fixedNavbar: isfixTab }'>
            <div class="custom-navbar">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="main-menu main-menu-light">
              <ul class="main-menu-item-ul">
                <li class="main-menu-item-ul-li" :class="[routerName=='home'?'active':'']"><router-link to="/">Home</router-link></li>
                <li class="main-menu-item-ul-li" :class="[routerName=='about'?'active':'']"><router-link to="/about">About</router-link>
                  <ul class="sub-menu ">
                    <li><router-link to="/about#message">Dean's message</router-link></li>
                    <li><router-link to="/about#leader">Current leaders</router-link></li>
                    <li><router-link to="/about#map">Campus map</router-link></li>
                  </ul>
                </li>
                <li class="main-menu-item-ul-li" :class="[routerName=='introduction'?'active':'']"><router-link to="/introduction">Introduction</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/introduction#campus">About the Campus</router-link></li>
                    <li><router-link to="/introduction#majors">Majors</router-link></li>
                    <li><router-link to="/introduction#Employment">Enrollment & Employment</router-link></li>
                  </ul>
                </li>
                <li class="main-menu-item-ul-li"  :class="[routerName=='schools'?'active':'']"><router-link to="/schoolDetails?id=1">Schools</router-link>
                  <ul class="sub-menu ">
                    <li><router-link to="/schoolDetails?id=1">Sino-French Institute</router-link></li>
                    <li><router-link to="/schoolDetails?id=2">School of Smart Governance</router-link></li>
                    <li><router-link to="/schoolDetails?id=3">Silk Road School</router-link></li>
                    <li><router-link to="/schoolDetails?id=4">International College</router-link></li>
                  </ul>
                </li>

                <li class="main-menu-item-ul-li"  :class="[routerName=='collaboration'?'active':'']"><router-link to="/collaboration">Collaboration</router-link></li>

<!--                <li><a href="#">pages</a>-->
<!--                  <ul class="sub-menu">-->
<!--                    <li><router-link to="/jobSearch">Job Search</router-link></li>-->
<!--                    <li><router-link to="/jobSingle">Job Single</router-link></li>-->
<!--                    <li><router-link to="/pricingPlan">Pricing Plan</router-link></li>-->
<!--                    <li><router-link to="/elements">Elements</router-link></li>-->
<!--                  </ul>-->
<!--                </li>-->
<!--                <li class="menu-btn">-->
<!--                  <a href="#" class="login">log in</a>-->
<!--                  <a href="#" class="template-btn">sign up</a>-->
<!--                </li>-->
              </ul>
            </div>
          </div>
        </div>

    </div>
  </header>
  <!-- Header Area End -->

  <router-view></router-view>

  <!-- Footer Area Starts -->

<!--  http://en.sc.ruc.edu.cn/static/images/banner4.jpg-->
  <footer class="footer-area">
    <div class="footer-left"></div>
    <div class="footer-content">
      <div class="row">
        <div class="col-lg-12">
          <div class="footer-logo wow slideInLeft">
            <a href="index.html"><img src="http://en.sc.ruc.edu.cn/static/images/home/footer-logo.png" alt="logo"></a>
          </div>
          <div class="footer-text wow slideInRight">
            <h2>CONTACT</h2>
            <p>
              Add:No.158 Ren'ai Road, Dushulake High Education District, Suzhou, Jiangsu Province,215123,P.R.  China
            </p>
<!--            <p>Tel:86-10-82509597 E-mail:international@ruc.edu.cn</p>-->
              <p style="margin-top: 20px; font-weight: 900;">
                AboutPrivacy copyright  Copyright © 2023 RUC.EDU.CN  <a href="https://beian.miit.gov.cn/">京公网安备110402430004号</a>  <a href="https://beian.miit.gov.cn/">京ICP备05007162号-1</a>
              </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-right"></div>
  </footer>
  <!-- Footer Area End -->

</div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      routerName: this.$router.history.current.name || '',
      isfixTab: false
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      this.routerName = to.name
      // 这里可以编写处理路由变化的逻辑
      next()
    })
  },
  methods: {
    handleTabFix () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var offsetTop = document.querySelector('#testNavBar').offsetTop
      scrollTop > offsetTop ? this.isfixTab = true : this.isfixTab = false
    }
  },
  // 监听页面滚动
  mounted () {
    window.addEventListener('scroll', this.handleTabFix, true)
  },
  // 离开当前组件前一定要清除滚动监听，否则进入其他路由会报错
  beforeRouteLeave (to, from, next) {
    window.removeEventListener('scroll', this.handleTabFix, true)
    next()
  }
}
</script>
<style lang="scss" scoped>
.fixedNavbar{
  position:fixed;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 0.05rem solid #f8f8f8;
  background: rgba(85, 40, 40, .5);
  -webkit-transition: .5s;
  -moz-transition: .5s;
  -o-transition: .5s;
  transition: .5s;

  .main-menu.main-menu-light li >a {
    color: #fff;
    font-size: 16px !important;
    margin: 0 10px !important;
    -webkit-transition: .5s;
    -moz-transition: .5s;
    -o-transition: .5s;
    transition: .5s;
  }
}
</style>




// WEBPACK FOOTER //
// App.vue?7ef4ef8a